(function ($) {
  $(function () {
    $('#filterModal').on('submit', 'form', function (e) {
      setTimeout(function () {
        $('#filterModal').modal('hide');
      }, 100);
    });
  });
})(jQuery);
